import React from "react";
import "./App.css";
import Loader from "./components/loader/Loader";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LoadingBlock from "./components/loader/LoadingBlock";
import Auth0Provider from "./features/auth/auth0Provider";
import Layout from "./layouts/Layout";
import PermissionProvider from "./features/configurations/PermissionProvider";

const BookingTable = React.lazy(
  () => import("./features/booking-table/bookingTable")
);
const ReportTable = React.lazy(
  () => import("./features/report-table/reportTable")
);
const ErrorNotFound = React.lazy(
  () => import("./components/error/ErrorNotFound")
);

function App() {
  return (
    <Router>
      <Auth0Provider>
        <Layout>
          <PermissionProvider>
            <React.Suspense fallback={<LoadingBlock />}>
              <Routes>
                <Route index element={<BookingTable />} />
                <Route path="/report" element={<ReportTable />} />
                <Route path="*" element={<ErrorNotFound />} />
              </Routes>
            </React.Suspense>
          </PermissionProvider>
        </Layout>
      </Auth0Provider>
    </Router>
  );
}

export default withAuthenticationRequired(App, {
  onRedirecting: () => <Loader />,
});
